export default {
  searchLabel: 'Silahkan masukan no resi',
  searchPlaceholder: 'Masukan nomer resi',
  dataNotFound: 'Silahkan memasukan nomor resi terlebih dulu',
  invalidAWB: 'Nomor resi tidak valid',
  inputOtherAWB: 'Nomor resi yang kamu masukan tidak valid, silahkan masukan nomer resi lain',
  logisticName: 'Nama Logistrik',
  service: 'Layanan',
  AWB: 'No. Resi',
  deliveredDate: 'Tanggal Dikirim',
  sender: 'Pengirim',
  receiver: 'Penerima'
}
